// 路由
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

// Router.beforeEnter((to, from, next) => {
//   if (to.path === '/zzf-board') {
//     window.open(this.$Router.resolve('@/views/home/ZzfBoard').href, '_blank');
//     next(false); // 阻止默认导航
//   } else {
//     next();
//   }
// });


export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      component: () => import('@/components/common/Login.vue'),
      beforeEnter: (to, from, next) => {
        if (localStorage.getItem('token')) {
          next('/')
        } else {
          next()
        }
      }
    },
    {
      path: '/not-found',
      component: () => import('@/components/common/NotFound'),
      name: '404'
    },
    {
      path: '/zzf-board',
      component: () => import('@/views/home/ZzfBoard'),
      name: '周转房'
      // beforeEnter: () => {
      //   window.open(this.Router.resolve('@/views/home/ZzfBoard').href, '_blank');
      // }
    },
    {
      path: '/',
      name: '',
      component: () => import('@/views/Index'),
      redirect: 'home',
      beforeEnter: (to, from, next) => {
        if (localStorage.getItem('token')) {
          next()
        } else {
          next('/login')
        }
      },
      children: [
        {
          path: 'home',
          meta: {
            title: '数据总览'
          },
          component: () => import('@/views/home/Home')
        },
        {
          path: 'dormitory-monitor',
          meta: {
            title: '归寝监控'
          },
          component: () => import('@/views/home/DormitoryMonitor')
        },
        {
          path: 'device-monitor',
          meta: {
            title: '设备监控'
          },
          component: () => import('@/views/home/DeviceMonitor')
        },
        {
          path: 'nhbigscreen',
          meta: {
            title: '数据大屏'
          },
          //redirect: '/zzf-board'
          component: () => import('@/views/home/NhZzfBigScreen')
        },
        // ---------------------------业务管理--------------------------------
        {
          path: 'tenement-manage',
          meta: {
            title: '租住管理'
          },
          component: () => import('@/views/business/tenement/ManageList')
        },
        {
          path: 'dev-alarm',
          meta: {
            title: '告警管理'
          },
          component: () => import('@/views/business/devalarm/DevAlarmList')
        },
        {
          path: '/meter-read',
          meta: {
            title: '抄表管理'
          },
          component: () => import('@/views/business/meterRead/MeterReadList')
        },
        {
          path: '/notice',
          meta: {
            title: '公告管理'
          },
          component: () => import('@/views/business/notice/notice')
        },
        {
          path: 'school-open',
          meta: {
            title: '开学迎新'
          },
          component: () => import('@/views/business/schoolOpen/SchoolOpen')
        },
        {
          path: 'graduation',
          meta: {
            title: '毕业离校'
          },
          component: () => import('@/views/business/graduation/Graduation')
        },
        {
          path: 'change',
          meta: {
            title: '换寝管理'
          },
          component: () => import('@/views/business/change/ChangeList')
        },
        {
          path: 'remote-open',
          meta: {
            title: '远程开门'
          },
          component: () => import('@/views/business/remoteOpen/RemoteOpen')
        },
        {
          path: 'emergency',
          meta: {
            title: '应急开门'
          },
          component: () => import('@/views/business/emergency/EmergencyList')
        },
        {
          path: 'dormitory',
          meta: {
            title: '归寝查询'
          },
          component: () => import('@/views/business/dormitory/DormitoryList')
        },
        {
          path: 'dormitory-log',
          meta: {
            title: '宿管日志'
          },
          component: () => import('@/views/business/dormitoryLog/DormitoryLog')
        },
        {
          path: 'attendance',
          meta: {
            title: '简单考勤'
          },
          component: () => import('@/views/business/attendance/Attendance')
        },
        // ---------------------------人事管理--------------------------------
        {
          path: 'human',
          meta: {
            title: '人员管理'
          },
          component: () => import('@/views/humanResources/human/HumanList')
        },
        {
          path: 'card',
          meta: {
            title: '卡片管理'
          },
          component: () => import('@/views/humanResources/card/CardList')
        },
        {
          path: 'hotel',
          meta: {
            title: '入住管理'
          },
          component: () => import('@/views/humanResources/hotel/HotelList')
        },
        {
          path: 'visitor',
          meta: {
            title: '访客管理'
          },
          component: () => import('@/views/humanResources/visitor/VisitorList')
        },
        {
          path: 'access',
          meta: {
            title: '门禁规则'
          },
          component: () => import('@/views/humanResources/access/AccessList')
        },
        {
          path: 'auth-record',
          meta: {
            title: '授权记录查询'
          },
          component: () =>
            import('@/views/humanResources/authRecord/AuthRecordList')
        },
        {
          path: 'record',
          meta: {
            title: '开门记录查询'
          },
          component: () => import('@/views/humanResources/record/RecordList')
        },
        // ---------------------------设备管理--------------------------------
        {
          path: 'gateway',
          meta: {
            title: '网关管理'
          },
          component: () => import('@/views/device/gateway/GatewayList')
        },
        {
          path: 'gateway-act',
          meta: {
            title: '网关激活'
          },
          component: () => import('@/views/device/gatewayAct/GatewayActList')
        },
        {
          path: 'lock',
          meta: {
            title: '门锁管理'
          },
          component: () => import('@/views/device/lock/LockList')
        },
        {
          path: 'lock-act',
          meta: {
            title: '设备激活'
          },
          component: () => import('@/views/device/lockAct/LockAct')
        },
        {
          path: 'lock-install',
          meta: {
            title: '设备出厂设置'
          },
          component: () => import('@/views/device/lockInstall/LockInstall')
        },
        {
          path: 'lock-log',
          meta: {
            title: '设备日志'
          },
          component: () => import('@/views/device/lockLog/LockLog')
        },
        {
          path: 'alarm',
          meta: {
            title: '报警查询'
          },
          component: () => import('@/views/device/alarm/AlarmList')
        },
        {
          path: 'firefacilities',
          meta: {
            title: '烟感管理'
          },
          component: () => import('@/views/device/fireFacilities/FireFacilitieList')
        },
        {
          path: 'repair',
          meta: {
            title: '报修管理'
          },
          component: () => import('@/views/device/repair/RepairList')
        },
        // ---------------------------基础设置--------------------------------
        {
          path: 'person',
          meta: {
            title: '人员机构'
          },
          component: () => import('@/views/basic/person/PersonList')
        },
        {
          path: 'building',
          meta: {
            title: '楼宇管理'
          },
          component: () => import('@/views/basic/building/BuilingList')
        },
        {
          path: 'room',
          meta: {
            title: '房间管理'
          },
          component: () => import('@/views/basic/room/RoomList')
        },
        {
          path: 'household',
          meta: {
            title: '房屋配置'
          },
          component: () => import('@/views/basic/household/Household')
        },
        {
          path: 'time',
          meta: {
            title: '时段管理'
          },
          component: () => import('@/views/basic/time/TimeList')
        },
        {
          path: 'holiday',
          meta: {
            title: '假日设置'
          },
          component: () => import('@/views/basic/holiday/HolidayList')
        },
        {
          path: 'bed-time',
          meta: {
            title: '归寝设置'
          },
          component: () => import('@/views/basic/bedTime/BedTime')
        },
        {
          path: 'alarm-set',
          meta: {
            title: '报警设置'
          },
          component: () => import('@/views/basic/alarm/Alarm')
        },
        // ---------------------------系统管理--------------------------------
        {
          path: 'admin',
          meta: {
            title: '个人设置'
          },
          component: () => import('@/views/system/admin/Admin')
        },
        {
          path: 'role',
          meta: {
            title: '角色管理'
          },
          component: () => import('@/views/system/role/RoleList')
        },
        {
          path: 'user',
          meta: {
            title: '用户管理'
          },
          component: () => import('@/views/system/user/UserList')
        },
        {
          path: 'repair-set',
          meta: {
            title: '维修设置'
          },
          component: () => import('@/views/system/repair/RepairSet')
        },
        {
          path: 'menu',
          meta: {
            title: '菜单管理'
          },
          component: () => import('@/views/system/menu/MenuList')
        },
        {
          path: 'type',
          meta: {
            title: '字典管理'
          },
          component: () => import('@/views/system/type/Type')
        },
        {
          path: 'system-log',
          meta: {
            title: '系统日志'
          },
          component: () => import('@/views/system/SystemLog')
        },
        {
          path: 'system',
          meta: {
            title: '系统参数'
          },
          component: () => import('@/views/system/System')
        }
      ]
    },
    {
      path: '*',
      redirect: {
        path: '/not-found'
      }
    }
  ]
})
